import type { DialogConfig } from '#types/config/components/dialog'
import type { RecursivePartial } from '#types/utils'

export default {
  dialogOptions: {
    type: 'panel',
    size: {
      sm: 'lg',
      md: 'sm'
    }
  }
} satisfies RecursivePartial<DialogConfig['cartChangeShippingMethod']>
